// Dependencias
import currencyFormat from './currencyFormater';

/**
 * Convierte un número a string en con el formato
 * de comillas por cada 3 dígitos.
 * @param {Number|String} num Número a convertir
 * @param {Boolean} round Bandera para redondear el número.
 * @returns {String}
 */
export default (num = '', round = false) => {
  const regExp = round ? /\$|[.][0-9]{2}/g : /\$/g;
  const value = round ? Math.round(num) : num;
  const output = currencyFormat(value);
  return output.replace(regExp, '');
};
